// extracted by mini-css-extract-plugin
module.exports = {"box":"TaskBox_box__YvDyg","grow":"TaskBox_grow__gpXMP","boxRight":"TaskBox_boxRight__bNYrw"};